import { render, staticRenderFns } from "./TicketInfoColumn.vue?vue&type=template&id=2387d276&scoped=true"
import script from "./TicketInfoColumn.vue?vue&type=script&lang=js"
export * from "./TicketInfoColumn.vue?vue&type=script&lang=js"
import style0 from "./TicketInfoColumn.vue?vue&type=style&index=0&id=2387d276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387d276",
  null
  
)

export default component.exports